import { Typography } from '@capsule/consumer-design-system';

import styled from 'styled-components';

const BaseSubtitleText = styled(Typography)`
  padding: ${props => props.theme.space.s1} 0 ${props => props.theme.space.s4};
`;
export const SubtitleText = styled(BaseSubtitleText)`
  color: ${props => props.theme.colors.capsuleGreen80};
`;

export const PostponedSubtitleText = styled(BaseSubtitleText)`
  color: ${props => props.theme.colors.capsuleGray50};
`;
